import React from 'react';
import { useTEF } from 'src/tef/components/providers/TEFProvider';
import { cn } from 'src/tef/components/utils/cn';
import { forwardProps } from 'src/tef/components/utils/forwardProps';
import type { ForwardedHTMLProps } from 'src/tef/components/utils/types';

interface RadioInputProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'>, ForwardedHTMLProps {
  label?: string;
  className?: string;
}

export const RadioInput = React.forwardRef<HTMLInputElement, RadioInputProps>(({ label, className, ...props }, ref) => {
  const tef = useTEF();
  const forwardedProps = forwardProps(props);

  return (
    <div className={cn('flex items-center', className)}>
      <input
        ref={ref}
        type="radio"
        className={cn(
          'w-4 h-4',
          'border',
          tef.colors.inputBorder,
          'text-primary',
          'focus:ring-2',
          'focus:ring-primary',
          'focus:ring-offset-2',
          'transition-colors'
        )}
        {...forwardedProps}
        {...props}
      />
      {label && (
        <label htmlFor={props.id} className={cn('ml-2', tef.typography.textSm, tef.colors.foreground)}>
          {label}
        </label>
      )}
    </div>
  );
});

RadioInput.displayName = 'RadioInput';
